var map = {
	"./blog.yml": 117,
	"./cloud.yml": 118,
	"./color.yml": 119,
	"./country.yml": 120,
	"./dio.yml": 121,
	"./doc.yml": 122,
	"./emoji.yml": 123,
	"./git.yml": 124,
	"./icon.yml": 125,
	"./license.yml": 126,
	"./link.yml": 127,
	"./metrics.yml": 128,
	"./people.yml": 129,
	"./soft.yml": 130,
	"./src.yml": 131,
	"./status.yml": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;